const studentMissionState = {
  locked: 'locked',
  open: 'open',
  visited: 'visited',
};

export default studentMissionState;
